import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing } = redesignTheme;

export const useCompassResultSectionStyles = makeStyles(() => ({
  sectionBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  sectionTitle: {
    margin: 0,
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    lineHeight: 'normal',
  },
}));
